// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"91f159ec","96":"34b6420f","233":"78ed695d","453":"aefd2f63","469":"7df4bcb9","532":"ab1bcb2c","731":"a55a0972"}[chunkId] + ".chunk.js";
};